module.exports = __webpack_public_path__ + "img/brand_44.e6163edb.png";